import { render, staticRenderFns } from "./UserViewMatter.vue?vue&type=template&id=7a1c9bb0"
import script from "./UserViewMatter.vue?vue&type=script&lang=js"
export * from "./UserViewMatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports